<template>
    <form @submit.prevent="save" v-pml-block="isLoading">
        <div class="card-box">
            <div class="row">
                <div class="col-xs-12 col-sm-6 col-md-4 m-b-15" :class="{ 'has-error': errors['content.title'] }">
                    <h5 class="m-t-0 m-b-5"><b>{{ $t('name') }}</b></h5>
                    <small class="show text-muted m-b-5">{{ $t('choose_a_name_for_the_integration') }}</small>
                    <input type="text" v-model="record.content.title" class="form-control" v-pml-focus ref="mainInput">
                    <span class="error" v-if="errors['content.title']">{{ errors['content.title'][0] }}</span>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-4 m-b-15" :class="{ 'has-error': errors['content.domain'] }">
                    <h5 class="m-t-0 m-b-5"><b>{{ $t('domain') }}</b></h5>
                    <small class="show text-muted m-b-5">{{ $t('_integrations.in_forms.line_10') }}</small>
                    <input type="text" v-model="record.content.domain" class="form-control">
                    <span class="error" v-if="errors['content.domain']">{{ errors['content.domain'][0] }}</span>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-4 m-b-15" :class="{ 'has-error': errors['content.follower_id'] }">
                    <h5 class="m-t-0 m-b-5"><b>{{ $t('follower') }}</b></h5>
                    <small class="show text-muted m-b-5">{{ $t('who_will_be_in_charge_for_follow_these_leads') }}</small>
                    <pml-select-members v-model="record.content.follower_id" :remove-from-options="record.content.member_id" :only-active="true" :only-follow="true"></pml-select-members>
                    <span class="error" v-if="errors['content.follower_id']">{{ errors['content.follower_id'] }}</span>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12 col-sm-6 col-md-4 m-b-15" :class="{ 'has-error': errors['content.source_id'] }">
                    <h5 class="m-b-5"><b>{{ $t('source') }}</b></h5>
                    <pml-select v-model="record.content.source_id" :options="sources"></pml-select>
                    <span class="error" v-if="errors['content.source_id']">{{ errors['content.source_id'][0] }}</span>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-4 m-b-15" :class="{ 'has-error': errors['content.segment_id'] }">
                    <h5 class="m-b-5"><b>{{ $t('segment') }}</b></h5>
                    <pml-select v-model="record.content.segment_id" :options="segments"></pml-select>
                    <span class="error" v-if="errors['content.segment_id']">{{ errors['content.segment_id'][0] }}</span>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-4 m-b-15" :class="{ 'has-error': errors['content.pipeline_step_id'] }">
                    <h5 class="m-b-5"><b>{{ $t('pipeline') }}</b></h5>
                    <pml-select-group v-model="record.content.pipeline_step_id" :options="pipelines" group-values="steps" group-label="name" class="select_pipeline"></pml-select-group>
                    <span class="error" v-if="errors['content.pipeline_step_id']">{{ errors['content.pipeline_step_id'][0] }}</span>
                </div>
            </div>
            <div class="clearfix" v-if="member.is_admin">
                <hr class="m-b-30">
                <div class="row">
                    <div class="col-xs-12 col-sm-12 col-md-4 m-b-15" :class="{ 'has-error': errors['content.auto_assign'] }">
                        <h5 class="m-t-0 m-b-5"><b>{{ $t('auto_distribution') }}</b></h5>
                        <small class="show text-muted m-b-10">{{ $t('distribute_leads_automatically') }}</small>
                        <pml-switch :value="record.content.auto_assign === 'yes'" @input="toggleActive()"></pml-switch>
                        <span class="error" v-if="errors['content.auto_assign']">{{ errors['content.auto_assign'][0] }}</span>
                    </div>
                    <div v-if="record.content.auto_assign === 'yes'" class="col-xs-12 col-sm-12 col-md-4 m-b-15" :class="{ 'has-error': errors['content.approach'] }">
                        <h5 class="m-t-0 m-b-5"><b>{{ $t('distribution_form') }}</b></h5>
                        <small class="show text-muted m-b-5">{{ $t('choose_how_the_system_should_distribute') }}</small>
                        <pml-select v-model="record.content.approach" :options="approaches"></pml-select>
                        <span class="error" v-if="errors['content.approach']">{{ errors['content.approach'][0] }}</span>
                    </div>
                    <div v-if="record.content.auto_assign === 'yes'" class="col-xs-12 col-sm-12 col-md-4 m-b-15" :class="{ 'has-error': errors['content.available_members'] }">
                        <h5 class="m-t-0 m-b-5"><b>{{ $t('available_members') }}</b></h5>
                        <small class="show text-muted m-b-5">{{ $t('available_members_desc') }}</small>
                        <pml-multiselect v-model="record.content.available_members" :options="activeMembers()" label="full_name"></pml-multiselect>
                        <span class="error" v-if="errors['content.available_members']">{{ errors['content.available_members'][0] }}</span>
                    </div>
                    <div v-if="record.content.auto_assign === 'no'" class="col-xs-12 col-sm-12 col-md-8 m-b-15" :class="{ 'has-error': errors['content.member_id'] }">
                        <h5 class="m-t-0 m-b-5"><b>{{ $t('consultant') }}</b></h5>
                        <small class="show text-muted m-b-5">{{ $t('who_will_be_in_charge_for_these_leads') }}</small>
                        <pml-select-members v-model="record.content.member_id" :only-active="true" :remove-from-options="record.content.follower_id"></pml-select-members>
                        <span class="error" v-if="errors['content.member_id']">{{ errors['content.member_id'][0] }}</span>
                    </div>
                </div>
            </div>
            <hr>
            <div class="row text-center">
                <div class="col-xs-12">
                    <h5 class="m-b-5"><b>{{ $t('form_config') }}</b></h5>
                    <small class="show text-muted m-b-15">{{ $t('link_the_form_data_to_the_leads_info_on_pml') }}</small>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-6">
                    <h5 class="text-center p-5 text-info m-t-5 m-b-5 c_default">
                        <i class="fa fa-desktop m-b-5 m-t-5 f_size_22"></i>
                        <b class="show">{{ $t('form_fields') }}</b>
                    </h5>
                </div>
                <div class="col-xs-6">
                    <h5 class="text-center p-5 text-custom m-t-5 m-b-5">
                        <div class="m-b-5">
                            <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="18pt" height="18pt" viewBox="0 0 256.000000 256.000000" preserveAspectRatio="xMidYMid meet"><g transform="translate(0.000000,256.000000) scale(0.100000,-0.100000)" fill="#5fbeaa" stroke="none"><path d="M1162 2479 c-101 -50 -152 -128 -160 -245 -12 -185 113 -324 293 -324 180 0 305 138 293 324 -8 114 -61 196 -160 245 -51 26 -73 31 -133 31 -60 0 -82 -5 -133 -31z"/><path d="M805 1831 c-110 -53 -185 -162 -185 -271 l0 -55 173 -100 c374 -216 448 -255 483 -255 38 0 129 48 453 238 l213 125 -4 61 c-9 113 -80 210 -188 260 l-55 26 -415 0 -415 0 -60 -29z"/><path d="M625 1432 c-3 -3 -5 -47 -5 -97 l0 -92 61 -33 c107 -57 434 -251 440 -262 4 -6 12 -9 19 -6 15 5 15 161 0 188 -5 9 -93 64 -197 122 -103 59 -216 124 -250 146 -34 22 -65 37 -68 34z"/><path d="M1897 1420 c-10 -10 -62 -41 -115 -69 -54 -28 -155 -86 -227 -129 l-130 -78 -5 -90 c-3 -49 -3 -93 1 -97 4 -5 107 50 230 121 123 71 239 137 257 146 l32 17 0 99 c0 106 -6 118 -43 80z"/><path d="M620 813 l1 -388 319 -185 c176 -102 326 -186 333 -188 7 -1 108 53 223 121 115 69 259 153 319 189 l110 64 3 354 c3 349 -2 448 -18 405 -4 -11 -67 -55 -145 -100 -75 -44 -180 -105 -233 -136 l-97 -57 -5 -86 -5 -87 -75 -41 -76 -41 -77 42 -77 43 0 88 c0 72 -3 89 -16 94 -9 4 -115 64 -235 134 -153 88 -219 132 -219 145 0 9 -7 17 -15 17 -13 0 -15 -50 -15 -387z"/></g></svg>
                        </div>
                        <b class="show">{{ $t('pump_my_lead_fields') }}</b>
                    </h5>
                </div>
            </div>
            <div class="row" v-for="(item, index) in record.content.from">
                <div class="col-xs-12 m-b-15">
                    <label class="input-group m-0">
                        <input type="text" v-model="record.content.from[index]" class="form-control" :placeholder="$t('input_name')" @input="checkKeyword(record.content.from[index], index)">
                        <span class="error" v-if="errors['content.from']">{{ errors['content.from'][0] }}</span>
                        <span class="input-group-addon"><i class="fa fa-arrow-circle-right"></i></span>
                        <div class="d_t_cell">
                            <pml-select v-model="record.content.to[index]" :options="treatFieldOptions(record.content.to[index])"></pml-select>
                            <span class="error" v-if="errors['content.to']">{{ errors['content.to'][0] }}</span>
                        </div>
                        <a @click="removeField(index)" class="btn btn-danger d_t_cell w_30" v-pml-tooltip="$t('delete')"><i class="fa fa-times"></i></a>
                    </label>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12">
                    <a @click="addField" class="btn btn-primary btn-sm m-t-10 m-b-15">
                        <span class="btn-label"><i class="fa fa-plus-circle"></i></span> {{ $t('add_field') }}
                    </a>
                </div>
            </div>
            <hr class="m-t-5">
            <div class="row">
                <div class="col-xs-12 clearfix">
                    <router-link :to="{ name: 'integrations.informs.index' }" class="btn btn-white btn_na">{{ $t('cancel') }}</router-link>
                    <button type="submit" class="btn btn-default pull-right" v-pml-block="isSaving">{{ $t('save') }}</button>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
    import Notify from 'utils/helpers/notify'
    import { trans } from 'utils/helpers/translation'
    import { getInForms, createInForms, updateInForms } from 'services/integrations'
    import { mapGetters } from 'vuex'
    import { isNil, filter } from 'lodash'
    import { removeByIndex } from 'utils/helpers/arrays'
    import { checkKeywords } from 'utils/helpers/keyword'

    export default {
        name: 'InFormsForm',
        data () {
            return {
                record: {
                    content: {
                        available_members: [],
                        source_id: null,
                        auto_assign: 'no',
                        from: [ 'first_name', 'email' ],
                        to: [ 'first_name', 'email' ]
                    }
                },
                errors: [],
                isLoading: false,
                isSaving: false
            }
        },
        mounted () {
            this.init()
        },
        watch: {
            '$route' () {
                this.init()
            }
        },
        computed: {
            ...mapGetters({
                'member': 'getMember',
                'activeMembers': 'getActiveMembers',
                'sources': 'getSources',
                'fieldOptions': 'getDealFields',
                'segments': 'getSegments',
                'pipelines': 'getPipelines',
                'approaches': 'getIntegrationIncomingApproaches'
            })
        },
        methods: {
            treatFieldOptions (selected) {
                let result = this.fieldOptions

                for (let i in this.record.content.to)
                    if (selected !== this.record.content.to[i])
                        result = filter(result, (record) => record.id !== this.record.content.to[i])

                return result
            },
            init () {
                if (!this.member.is_admin) {
                    this.record.content.member_id = this.member.id
                    this.record.content.auto_assign = 'no'
                }

                typeof this.$route.params.id !== 'undefined' ? this.fetchRecord(this.$route.params.id) : this.clear()
            },
            addField () {
                this.record.content.from.push('')
                this.record.content.to.push('')
            },
            removeField (index) {
                removeByIndex(this.record.content.from, index)
                removeByIndex(this.record.content.to, index)
            },
            fetchRecord (id) {
                this.isLoading = true

                getInForms(id)
                    .then(response => {
                        this.record = response.data
                        if (this.record.content.auto_assign === 'yes' && isNil(this.record.content.available_members))
                            this.record.content.available_members = this.activeMembers().map((item) => item.id)
                    })
                    .catch(() => { Notify.error(trans('_notifications.error')) })
                    .then(() => { this.isLoading = false })
            },
            save () {
                this.isSaving = true

                this.request()
                    .then(request => {
                        this.$emit('saved', request.data)
                        Notify.success(trans('the_record_has_been_saved'))
                        this.$router.push({ name: 'integrations.informs.index' })
                    })
                    .catch(error => {
                        Notify.error(trans('_notifications.error'))
                        this.errors = error.response.data.errors || []
                    })
                    .then(() => { this.isSaving = false })
            },
            request () {
                return isNil(this.record.id) ? createInForms(this.record) : updateInForms(this.$route.params.id, this.record)
            },
            toggleActive () {
                if (this.record.content.auto_assign === 'yes') {
                    this.record.content.auto_assign = 'no'
                } else {
                    this.record.content.auto_assign = 'yes'
                    this.record.content.available_members = this.activeMembers().map((item) => item.id)
                }
            },
            clear () {
                this.record = {
                    content: {
                        available_members: [],
                        auto_assign: 'no',
                        source_id: null,
                        from: [ 'first_name', 'email' ],
                        to: [ 'first_name', 'email' ]
                    }
                }

                this.errors = []
            },
            checkKeyword (keyword, index) {
                if (this.record.content.to.indexOf(checkKeywords(keyword)) === -1)
                    this.record.content.to[index] = checkKeywords(keyword)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/integrations/components/providers/in_forms/Form.vue